import styled from "styled-components";
import { Link } from "react-router-dom";
export const Wrapper = styled.div`
    
    
    margin: auto;
    padding:15px;
    font-size: ${({dropdown})=>(dropdown ? "x-small":"")};    
    text-decoration:none;

    `
export const Image = styled.img`

width: 100%;
max-width: 50px;
max-height:50px;
transition: all 2s;
object-fit: cover;

border-radius: 50%;
box-shadow: 0 5px 9px white inset, 0 5px 9px grey;


:hover {
    transform: rotateY(360deg);
    opacity: 80%;
}

`;    


export const Content = styled.div`
    
    display: grid;
    grid-auto-flow: column;
    
    
    width:100%;
    border-radius: 10px;
    box-shadow: ${props => (props.switchOn ? '0 5px 9px white inset':'0 5px 9px white inset, 0 5px 9px grey' )};
    padding: 10px;
    background: ${props=> (props.dropdown ? "var(--primaryColor)" : "var(--secondaryColor)")};
    background: ${props=> (props.switchOn ? "var(--primaryColor)" : "var(--secondaryColor)")};
    text-decoration:none;
   
    text-align: center;
    align-items: center;
    
    width: ${props=> (props.list?'50px':'')}

`
export const StyledLink = styled(Link)`
    text-decoration: none;
   
    
    &:focus, &:hover, &:visited, &:link, &:active {
        text-decoration: none;
        cursor: pointer;
    }
`
